import { useId } from 'react';
import { Box, Heading, Paragraph, ToggleCard } from '@zillow/constellation-10';
import type { TourConfirmationType } from '@zg-rentals/ts-z-calendar-client';

import TourConfirmationTypeCard from '../../../TourConfirmationTypeCard';
import { MD_BREAKPOINT, TOUR_CONFIRMATION_TYPE_LAYOUT, TOUR_OPTIONS } from '../../../../constants/TourCalendar';
import { useMediaQuery } from '@zg-rentals/react-hooks';

type TourCalendarConfigProps = {
  onTourTypeSelection: (tourType: TourConfirmationType) => void;
  tourConfirmationType?: TourConfirmationType;
};

const TourCalendarConfig = ({ onTourTypeSelection, tourConfirmationType }: TourCalendarConfigProps) => {
  const isScreenMobile = useMediaQuery(`(max-width: ${MD_BREAKPOINT})`);
  const headingId = useId();

  return (
    <>
      <Box css={{ marginTop: { md: 'tighter' } }} data-testid="TourCalendarConfig-Body">
        <Heading level={4} fontFamily="heading-alt" css={{ marginBottom: 'tighter' }} id={headingId}>
          Select the tour booking method that works best for you
        </Heading>
        <Paragraph color="text.subtle" css={{ marginBottom: { base: 'loose', md: 40 } }}>
          After a tour’s scheduled, we’ll send reminders so no one misses the tour. You can update your booking method
          at any time.
        </Paragraph>
      </Box>
      <Box
        role="group"
        aria-labelledby={headingId}
        css={{ display: 'flex', flexDirection: { base: 'column', md: 'row' }, gap: { base: 'default', md: 'loose' } }}
      >
        {TOUR_OPTIONS.map((tourOption, index) => (
          <ToggleCard
            css={{ maxWidth: { lg: '290px' } }}
            key={index}
            selected={tourOption.id === tourConfirmationType}
            onClick={() => onTourTypeSelection(tourOption.id)}
            data-testid={`TourCalendarConfig-TourType${index}`}
          >
            <TourConfirmationTypeCard
              layout={
                isScreenMobile ? TOUR_CONFIRMATION_TYPE_LAYOUT.HORIZONTAL : TOUR_CONFIRMATION_TYPE_LAYOUT.VERTICAL
              }
              tourOption={tourOption}
            />
          </ToggleCard>
        ))}
      </Box>
    </>
  );
};

export default TourCalendarConfig;
